import { takeUntil, Subject } from 'rxjs';

// import { metaService } from '../../js/meta-service';
import { modalService } from '../../js/modal-service';
import { scrollTrigger } from '../../js/scroll-trigger';
import { registerSplashBtns } from '../../js/splash-btn-service';

const apiUrl = document.querySelector('meta[name="api-url"]')?.content;

let destroy$ = new Subject();

const SpecialTags = {
  ALL: 'ALL'
}

const ArticleTypes = {
  TECH: 'tech',
  BUSINESS: 'business'
}

/* -------------------------MODAL------------------------------- */

let tags = [];
let filteredTags = [];
let search, rerenderTagsTimeout, close;
let tagEls = [];

function addModal() {
  const overlay = document.createElement('div');
  overlay.id = 'overlay';
  overlay.classList.add('overlay', 'hidden');

  document.body.append(overlay);

  listenSearchChanged();
  listenModalToClose();

  getTags();
}

function listenSearchChanged() {
  search = document.getElementById('search');

  search.addEventListener('keyup', handleSearchChange);
}

function handleSearchChange(event) {
  const search = (event.target).value;
  filteredTags = tags.filter(({ label }) => label.includes(search));

  if (rerenderTagsTimeout) {
    clearTimeout(rerenderTagsTimeout);
  }

  rerenderTagsTimeout = setTimeout(() => {
    renderTags();
  }, 300);
}

function listenModalToClose() {
  close = document.querySelector('.search-modal .close-modal');
  close.addEventListener('click', handleClose);
}

function handleClose() {
  modalService.closeModal(null);
}

async function getTags() {
  const res = await fetch(`${apiUrl}/tags?ln=${document.documentElement.lang}`);
  tags = await res.json();
  filteredTags = tags.slice(0, 5);
  renderTags();
}

function renderTags() {
  const container = document.querySelector('.search-modal .tags');

  const html = filteredTags.reduce((acc, cur) => {
    acc += `<button class="tag primary" id="${cur.id}">${cur.label}</button>`;
    return acc;
  }, '');

  container.innerHTML = html;

  handleTagSelected();
}

function handleTagSelected() {
  tagEls = [...document.querySelectorAll('.search-modal .tag')];

  tagEls.forEach((el) => el.addEventListener('click', tagSelected));
}

function tagSelected(event) {
  const el = event.target;

  const tag = el.id;
  const selectedTag = tags.find(({ id }) => id === +tag);

  modalService.closeModal(selectedTag);
}

/* -------------------------SEARCH------------------------------- */

let searchBtn, searchTag, articleEls, articleContainer;
let searchedTag, selectedQuickTag;
let quickTagsContainer, searchTagContainer;

function listenArticlesSearch() {
  searchBtn = document.getElementById('searchBtn');
  searchBtn.addEventListener('click', openSearchModal);

  articleContainer = document.querySelector('.articles-wrap');
  articleEls = [...document.querySelectorAll('.article-item')];
}

function openSearchModal() {
  modalService.openModal('searchModal')
    .pipe(takeUntil(destroy$))
    .subscribe((selectedTag) => {
      if (selectedTag) {
        searchedTag = selectedTag;

        handleSearchTagChanged(selectedTag);

        rerenderArticles();
      }
    });
}

function rerenderArticles() {
  if (!searchedTag && (!selectedQuickTag || selectedQuickTag === SpecialTags.ALL)) {
    articleContainer.innerHTML = '';
    articleEls.forEach((article) => {
      articleContainer.appendChild(article);
    });

    return;
  }

  if (searchedTag) {
    filterArticlesByTag(`${searchedTag.id}`);
    return;
  }

  if (selectedQuickTag) {
    switch(selectedQuickTag) {
      case ArticleTypes.BUSINESS:
      case ArticleTypes.TECH:
        filterByType(selectedQuickTag);
        break;
      default:
        filterArticlesByTag(selectedQuickTag);
    }
    return;
  }
}

function filterArticlesByTag(tagId) {
  articleEls.forEach((article) => {
    const tags = [...article.querySelectorAll('.tag')];
    const ifElExist = articleContainer.contains(article);

    if (!tags.find(({ id }) => id === tagId)) {
      if (ifElExist) {
        articleContainer.removeChild(article);
      }
    } else if (!ifElExist) {
      articleContainer.appendChild(article);
    }
  });
}

function filterByType(type) {
  articleEls.forEach((article) => {
    const type = article.dataset.type;
    const ifElExist = articleContainer.contains(article);

    if (type !== selectedQuickTag) {
      if (ifElExist) {
        articleContainer.removeChild(article);
      }
    } else if (!ifElExist) {
      articleContainer.appendChild(article);
    }
  });
}

function handleSearchTagChanged(searchedTag) {
  if (searchedTag) {
    searchTagContainer.innerHTML = `<button class="tag primary active closed" id="${searchedTag.id}">${searchedTag.label}</button>`;
    searchTag = document.querySelector('.search-tag .tag');
    quickTagsContainer.classList.add('hidden');
    searchTag.addEventListener('click', showAllTags);
  }
}

function showAllTags() {
  quickTagsContainer.classList.remove('hidden');
  searchTagContainer.innerHTML = '';
}

/* -------------------------TAGS------------------------------- */

let quickTags = [];

function handleQuickTagSelected() {
  quickTagsContainer = document.querySelector('.quick-tags');
  searchTagContainer = document.querySelector('.search-tag');
  quickTags = document.querySelectorAll('#tagsContainer button');

  quickTags.forEach((el) => el.addEventListener('click', quickTagSelected));
}

function quickTagSelected(event) {
  const el = event.target;

  quickTags.forEach((tag) => tag.classList.remove('active'));

  el.classList.add('active');

  const tag = el.id;

  selectedQuickTag = tag;
  searchedTag = null;
  rerenderArticles();
}

/* -------------------------COMMON------------------------------- */

function registerLiveLine(el) {
  scrollTrigger.registerElement(el, {
    start: 'top 20%',
    once: true
  })
    .pipe(takeUntil(destroy$))
    .subscribe(() => {
      el.classList.add('active');
    });
}

function setLiveLine() {
  const liveLines = document.querySelectorAll('.live-line');
  liveLines.forEach((liveLine) => {
    registerLiveLine(liveLine);
  });
}

let splashBtns = [];

function initSplashBtns() {
  splashBtns = document.querySelectorAll('.splash-btn');

  registerSplashBtns(splashBtns);
}

// metaService.setWebsiteMeta(); // TODO: move to template (actual for SSR only)

addEventListener('DOMContentLoaded', () => {
  addModal();
  listenArticlesSearch();
  handleQuickTagSelected();
  setLiveLine();
  initSplashBtns();
});
